module.exports = __webpack_public_path__ + "media/images/landkit/covers/cover-6-b16fe1e0fdd7a9549a3e28392482b756.jpg";